import { render, staticRenderFns } from "./UserAdminRequests.vue?vue&type=template&id=36186478&scoped=true"
import script from "./UserAdminRequests.vue?vue&type=script&lang=js"
export * from "./UserAdminRequests.vue?vue&type=script&lang=js"
import style0 from "./UserAdminRequests.vue?vue&type=style&index=0&id=36186478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36186478",
  null
  
)

export default component.exports